import { Logic, Operator } from 'core-components/types'

import { GlobalPartnerTypes } from '../../../../../models/globalPartnerTypes'

interface IGetOfferingsFilterParams {
  rtms: GlobalPartnerTypes[]
  fYear: number
}

export const getOfferingsFilter = ({ rtms, fYear }: IGetOfferingsFilterParams) => {
  const filters = rtms.map((rtm) => ({
    field: 'PartnerType',
    value: rtm,
    operator: Operator.EQUAL,
  }))

  return {
    logic: Logic.AND,
    filters: [
      {
        field: 'FYear',
        operator: Operator.EQUAL,
        value: fYear,
      },
      {
        logic: Logic.OR,
        filters,
      },
    ],
  }
}
